<template>
  <div class="body__container">
    <div
      class="text-xs-center"
      style="
        margin-top: 30px;
        letter-spacing: 0.1rem;
        position: relative;
        z-index: 1;
      "
    >
      <h1>Payment setting</h1>
    </div>
    <div
      style="
        display: flex;
        justify-content: center;
        position: relative;
        z-index: 1;
      "
    >
      <table style="margin-top: 30px; width: 60%">
        <!-- <caption>
          Inapp payment
        </caption> -->
        <colgroup>
          <col class="batman" />
          <col span="1" class="flash" v-for="n in paymentMethod" :key="n" />
        </colgroup>
        <tr>
          <th style="font-size: 18px; background-color: rgba(253, 223, 0, 0.7)">
            Methods
          </th>
          <th
            scope="col"
            v-for="(service, index) in serviceList"
            :key="index"
            style="
              font-size: 16px;
              width: 25%;
              background-color: rgba(1, 1, 1, 0.6);
              color: white;
            "
          >
            {{ service.name }}
          </th>
        </tr>
        <tr v-for="(payment, index) in paymentMethod" :key="index">
          <th scope="row" style="font-size: 14px; padding: 20px 0px">
            {{ payment.name }}
          </th>
          <td>
            <div style="position: relative">
              <v-switch
                v-if="'food' in payment"
                style="
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                "
                v-model="payment.food.status"
                color="primary"
                @change="togglePayment(payment.food)"
              ></v-switch>
            </div>
          </td>
          <td>
            <div style="position: relative">
              <v-switch
                v-if="'messenger' in payment"
                style="
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                "
                v-model="payment.messenger.status"
                color="primary"
                @change="togglePayment(payment.messenger)"
              ></v-switch>
            </div>
          </td>
          <td>
            <div style="position: relative">
              <v-switch
                v-if="'wellness' in payment"
                style="
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                "
                v-model="payment.wellness.status"
                color="primary"
                @change="togglePayment(payment.wellness)"
              ></v-switch>
            </div>
          </td>
          <td>
            <div style="position: relative">
              <v-switch
                v-if="'dinein' in payment"
                style="
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                "
                v-model="payment.dinein.status"
                color="primary"
                @change="togglePayment(payment.dinein)"
              ></v-switch>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <img
      style="
        position: absolute;
        right: -10px;
        bottom: -100px;
        transform: rotate(-25deg);
        z-index: 0;
      "
      src="../../../assets/bg-error.png"
      width="900px"
      alt=""
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      serviceList: [
        { name: "Food Delivery" },
        { name: "Messenger" },
        { name: "Wellness" },
        { name: "Dinein" },
      ],
      paymentMethod: [
        {
          id: 1,
          name: "Cash on delivery",
          food: { id: null, status: false },
          messenger: { id: null, status: false },
          // wellness: { id: null, status: false },
        },
        {
          id: 2,
          name: "Debit/Credit Card",
          food: { id: null, status: false },
          messenger: { id: null, status: false },
          wellness: { id: null, status: false },
          dinein: { id: null, status: false },
        },
        {
          id: 3,
          name: "Transfer/PromptPay",
          food: { id: null, status: false },
          messenger: { id: null, status: false },
          // wellness: { id: null, status: false },
          dinein: { id: null, status: false },
        },
        {
          id: 4,
          name: "Cryptocurrency",
          food: { id: null, status: false },
          // messenger: { id: null, status: false },
          // wellness: { id: null, status: false },
        },
        {
          id: 5,
          name: "QR PromptPay",
          dinein: { id: null, status: false },
        },
      ],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions({
      fetchPaymentMethodList: "fetchFoodSetAppBack/fetchPaymentMethodList",
      changePaymentMethodStatus:
        "fetchFoodSetAppBack/changePaymentMethodStatus",
    }),
    async getData() {
      let response = await this.fetchPaymentMethodList();
      console.log(response.data);
      for (let province of response.data) {
        if (
          province.province_name_en.replace(/ /g, "").toLowerCase() ===
          this.$route.params.province.toLowerCase()
        ) {
          for (let service of province.province_service) {
            if (service.servince_id == 1) {
              if (
                service.servince_on_use.length > 0 &&
                service.servince_on_use[0].service_on_use_methods_of_payment.includes(
                  1
                )
              ) {
                this.paymentMethod[0].food.status = true;
              }

              if (
                service.servince_on_use.length > 0 &&
                service.servince_on_use[0].service_on_use_methods_of_payment.includes(
                  2
                )
              ) {
                this.paymentMethod[1].food.status = true;
              }
              if (
                service.servince_on_use.length > 0 &&
                service.servince_on_use[0].service_on_use_methods_of_payment.includes(
                  3
                )
              ) {
                this.paymentMethod[2].food.status = true;
              }
              if (
                service.servince_on_use.length > 0 &&
                service.servince_on_use[0].service_on_use_methods_of_payment.includes(
                  4
                )
              ) {
                this.paymentMethod[3].food.status = true;
              }

              if (
                service.servince_on_use.length > 0 &&
                service.servince_on_use[0].service_on_use_methods_of_payment.includes(
                  5
                )
              ) {
                this.paymentMethod[4].food.status = true;
              }

              for (const item of this.paymentMethod) {
                if ("food" in item) {
                  item.food.id = service.servince_on_use[0].service_on_use_id;
                }
              }
            }

            if (service.servince_id == 2) {
              if (
                service.servince_on_use.length > 0 &&
                service.servince_on_use[0].service_on_use_methods_of_payment.includes(
                  1
                )
              ) {
                this.paymentMethod[0].messenger.id =
                  service.servince_on_use[0].service_on_use_id;
                this.paymentMethod[0].messenger.status = true;
              }

              if (
                service.servince_on_use.length > 0 &&
                service.servince_on_use[0].service_on_use_methods_of_payment.includes(
                  2
                )
              ) {
                this.paymentMethod[1].messenger.status = true;
              }
              if (
                service.servince_on_use.length > 0 &&
                service.servince_on_use[0].service_on_use_methods_of_payment.includes(
                  3
                )
              ) {
                this.paymentMethod[2].messenger.status = true;
              }
              if (
                service.servince_on_use.length > 0 &&
                service.servince_on_use[0].service_on_use_methods_of_payment.includes(
                  4
                )
              ) {
                this.paymentMethod[3].messenger.status = true;
              }

              if (
                service.servince_on_use.length > 0 &&
                service.servince_on_use[0].service_on_use_methods_of_payment.includes(
                  5
                )
              ) {
                this.paymentMethod[4].messenger.status = true;
              }

              for (const item of this.paymentMethod) {
                if ("messenger" in item) {
                  item.messenger.id =
                    service.servince_on_use[0].service_on_use_id;
                }
              }
            }

            if (service.servince_id == 5) {
              if (
                service.servince_on_use.length > 0 &&
                service.servince_on_use[0].service_on_use_methods_of_payment.includes(
                  1
                )
              ) {
                this.paymentMethod[0].wellness.id =
                  service.servince_on_use[0].service_on_use_id;
                this.paymentMethod[0].wellness.status = true;
              }

              if (
                service.servince_on_use.length > 0 &&
                service.servince_on_use[0].service_on_use_methods_of_payment.includes(
                  2
                )
              ) {
                this.paymentMethod[1].wellness.status = true;
              }
              if (
                service.servince_on_use.length > 0 &&
                service.servince_on_use[0].service_on_use_methods_of_payment.includes(
                  3
                )
              ) {
                this.paymentMethod[2].wellness.status = true;
              }
              if (
                service.servince_on_use.length > 0 &&
                service.servince_on_use[0].service_on_use_methods_of_payment.includes(
                  4
                )
              ) {
                this.paymentMethod[3].wellness.status = true;
              }

              if (
                service.servince_on_use.length > 0 &&
                service.servince_on_use[0].service_on_use_methods_of_payment.includes(
                  5
                )
              ) {
                this.paymentMethod[4].wellness.status = true;
              }

              for (const item of this.paymentMethod) {
                if ("wellness" in item) {
                  item.wellness.id =
                    service.servince_on_use[0].service_on_use_id;
                }
              }
            }

            if (service.servince_id == 9) {
              if (
                service.servince_on_use.length > 0 &&
                service.servince_on_use[0].service_on_use_methods_of_payment.includes(
                  1
                )
              ) {
                this.paymentMethod[0].dinein.id =
                  service.servince_on_use[0].service_on_use_id;
                this.paymentMethod[0].dinein.status = true;
              }

              if (
                service.servince_on_use.length > 0 &&
                service.servince_on_use[0].service_on_use_methods_of_payment.includes(
                  2
                )
              ) {
                this.paymentMethod[1].dinein.status = true;
              }
              if (
                service.servince_on_use.length > 0 &&
                service.servince_on_use[0].service_on_use_methods_of_payment.includes(
                  3
                )
              ) {
                this.paymentMethod[2].dinein.status = true;
              }
              if (
                service.servince_on_use.length > 0 &&
                service.servince_on_use[0].service_on_use_methods_of_payment.includes(
                  4
                )
              ) {
                this.paymentMethod[3].dinein.status = true;
              }

              if (
                service.servince_on_use.length > 0 &&
                service.servince_on_use[0].service_on_use_methods_of_payment.includes(
                  5
                )
              ) {
                this.paymentMethod[4].dinein.status = true;
              }

              for (const item of this.paymentMethod) {
                if ("dinein" in item) {
                  item.dinein.id = service.servince_on_use[0].service_on_use_id;
                }
              }
            }
          }
        }
      }
    },
    async togglePayment(payment_service) {
      let arr = this.paymentMethod.filter(
        (val) =>
          ("food" in val &&
            val.food.id == payment_service.id &&
            val.food.status == true) ||
          ("messenger" in val &&
            val.messenger.id == payment_service.id &&
            val.messenger.status == true) ||
          ("wellness" in val &&
            val.wellness.id == payment_service.id &&
            val.wellness.status == true) ||
          ("dinein" in val &&
            val.dinein.id == payment_service.id &&
            val.dinein.status == true)
      );

      let payload = {
        service_on_use_id: payment_service.id,
        service_on_use_methods_of_payment: arr.map((val) => val.id),
      };
      let res = await this.changePaymentMethodStatus(payload);
      if (res == false) {
        payment_service.status = !payment_service.status;
      }
    },
  },
};
</script>

<style scoped>
.batman {
  background-color: rgba(253, 223, 0, 0.5);
}

.flash {
  background-color: white;
}

.flash1 {
  background-color: white;
}

caption {
  padding: 8px;
  caption-side: bottom;
}

table {
  border-collapse: collapse;
  border: 2px solid black;
  letter-spacing: 1px;
  font-family: sans-serif;
  font-size: 0.7rem;
}

td,
th {
  border: 1px solid rgb(100, 100, 100);
  padding: 10px 10px;
}

td {
  text-align: center;
}

.body__container {
  background-color: white;
  overflow: hidden;
  /* background: url("../../../assets/bg-error.png"); */
  position: relative;
  height: calc(100vh - 100px);
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
